/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import { compose } from 'recompose';

import type { InjectedRouter } from 'js/lib/connectToRouter';
import connectToRouter from 'js/lib/connectToRouter';

import { Button, Typography2 } from '@coursera/cds-core';

import AuthenticationV3CtaTracking from 'bundles/authentication/shared/AuthenticationV3CtaTracking';
import TrackedButton from 'bundles/page/components/TrackedButton';

import _t from 'i18n!nls/video-logged-out-page';

type InputProps = {
  videosWatched: number;
  videoAllowance: number;
  clickedPlay?: boolean;
};

type Props = InputProps & {
  router: InjectedRouter;
};

type State = {
  componentDidMount: boolean;
};

const handleCTAClick = (router: InjectedRouter) => {
  router.replace({
    pathname: router.location.pathname,
    query: { ...router.location.query, authMode: 'signup', redirectTo: router.location.pathname },
  });
};

export class ContentGateEyebrow extends React.Component<Props, State> {
  state = {
    componentDidMount: false,
  };

  componentDidMount() {
    this.setState(() => ({ componentDidMount: true }));
  }

  render() {
    const { videosWatched, videoAllowance, clickedPlay, router } = this.props;
    const { componentDidMount } = this.state;

    let eyebrowMessage = _t("You've watched #{numVideosWatched} of #{numVideoAllowance} trial videos.", {
      numVideosWatched: videosWatched,
      numVideoAllowance: videoAllowance,
    });
    if (!videosWatched) {
      eyebrowMessage = _t('#{numVideoAllowance} trial videos available.', { numVideoAllowance: videoAllowance });
    } else if (clickedPlay) {
      eyebrowMessage = _t("You're watching trial video #{numVideosWatched} of #{numVideoAllowance}.", {
        numVideosWatched: videosWatched,
        numVideoAllowance: videoAllowance,
      });
    }

    if (componentDidMount) {
      return (
        <div className="vlp-gate-eyebrow">
          <Typography2 component="p" color="invertBody" variant="bodyPrimary" className="vlp-gate-eyebrow-text">
            <strong>
              {eyebrowMessage}
              &nbsp;
            </strong>
            {_t('Create an account to watch unlimited course videos.')}
          </Typography2>
          <AuthenticationV3CtaTracking>
            {(trackV3) => {
              const handleOnClick = () => {
                trackV3({ name: 'signup', sectionName: 'video_trial_banner' });
                handleCTAClick(router);
              };
              return (
                <Button
                  data-unit="cg-eyebrow-join-for-free"
                  variant="secondary"
                  component={TrackedButton}
                  trackingName="eyebrow_join_for_free"
                  className="vlp-gate-eyebrow-button vlp-gate-cta"
                  onClick={handleOnClick}
                  type="button"
                  withVisibilityTracking={false}
                  requireFullyVisible={false}
                  aria-label={_t('Join for free')}
                >
                  {_t('Join for free')}
                </Button>
              );
            }}
          </AuthenticationV3CtaTracking>
        </div>
      );
    } else {
      return <div className="vlp-gate-eyebrow" />;
    }
  }
}

export default compose<Props, InputProps>(connectToRouter<Props, InputProps>((router) => ({ router })))(
  ContentGateEyebrow
);
